// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullRegion,
} from 'common.data';

// Global Components
import * as React from 'react';

// Types
type $Props = $Translate & {
  activeItemId: null | string;
  data: Array<$FullRegion>;
  setItem: (arg0: {
    RegionId: string;
  }) => unknown;
};

function RegionsListView({
  activeItemId,
  data,
  setItem,
  t,
}: $Props) {
  return (
    <div className={'RegionsList'}>
      {data.map((dataItem: $FullRegion) => (
        <button
          className={`RegionsListItem btn btn_secondary btn_outlined w-full mb-3 ${activeItemId === dataItem.id ? 'btn_active' : ''}`}
          key={dataItem.id}
          onClick={() => setItem({
            RegionId: dataItem.id,
          })}
          title={dataItem.Name}
          type={'button'}
        >
          <img
            alt={dataItem.Domain}
            className={'max-h-4 mr-2 border'}
            src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${dataItem.Flag}.svg`}
          />
          <span>
            {dataItem.Flag}
          </span>
          <span className={'mx-auto'}>
            {dataItem.Name}
          </span>
        </button>
      ))}
      <div className={'text-center'}>
        <span>
          {`${t('Can not find your region?')} `}
        </span>
        <a
          className={'text-blue-400'}
          href={'mailto:Regattas.eu<info@regattas.eu>?subject=Hello'}
        >
          {t('Contact')}
        </a>
      </div>
    </div>
  );
}

export default RegionsListView;
